export const DEFAULT_SCHEME_COLOR = '#4b4b4b';
export const TILES_PER_PAGE = 100;
